module.exports = __webpack_public_path__ + "img/groupbuying_list.1e04fbf8.svg";